import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight, ArrowUpRight } from "lucide-react";

export const BoardRail = ({ models }) => {
  const rail = useRef(null);
  const scroll = (dir) => rail.current?.scrollBy({ left: dir * rail.current.clientWidth * 0.8, behavior: "smooth" });

  return (
    <section data-testid="board-rail" className="bg-white py-20 text-[#1c1418] md:py-28">
      <div className="mx-auto flex max-w-[1600px] items-end justify-between gap-6 px-5 md:px-10">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/60">Mainboard — {models.length} faces</p>
          <h2 className="mt-3 font-display text-5xl uppercase leading-[0.85] md:text-8xl">The Board</h2>
        </div>
        <div className="flex items-center gap-3">
          <Link to="/models" data-testid="board-rail-all" className="link-underline mr-3 hidden font-mono text-xs uppercase tracking-[0.25em] sm:block">View all</Link>
          {[[-1, ArrowLeft, "prev"], [1, ArrowRight, "next"]].map(([d, Icon, k]) => (
            <button key={k} onClick={() => scroll(d)} data-testid={`board-rail-${k}`} aria-label={k}
              className="grid h-12 w-12 place-items-center rounded-full border border-[#1c1418]/25 transition-colors hover:border-[#1c1418]">
              <Icon className="h-5 w-5 text-[#e9458f]" />
            </button>
          ))}
        </div>
      </div>

      <div ref={rail} data-lenis-prevent className="no-scrollbar mt-12 flex snap-x scroll-pl-5 gap-4 overflow-x-auto px-5 md:scroll-pl-10 md:gap-5 md:px-10">
        {models.map((m, i) => (
          <motion.div key={m.slug} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.7, delay: Math.min(i, 6) * 0.06 }}
            className="w-[62vw] shrink-0 snap-start sm:w-[34vw] lg:w-[17.5vw]">
            <Link to={`/models/${m.slug}`} data-testid={`board-rail-card-${m.slug}`} className="group block">
              <div className="aspect-[3/4] overflow-hidden bg-[#eeeeee]">
                <img src={m.images?.[0]} alt={m.name} loading="lazy"
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.05]" />
              </div>
              <div className="mt-3 flex items-baseline justify-between gap-2">
                <h3 className="font-display text-2xl uppercase leading-none">{m.name}</h3>
                <span className="font-mono text-[11px] text-[#1c1418]/60">{m.measurements?.height?.split(" - ")[0]}</span>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>

      <Link to="/models" className="mx-5 mt-8 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] sm:hidden">
        View all <ArrowUpRight className="h-4 w-4 text-[#e9458f]" />
      </Link>
    </section>
  );
};
